// Components
import '../../../../components/advertisements/results';
import RangeLiveValue from '../../../../utils/RangeLiveValue';

RangeLiveValue.init();
